export default "__VITE_ASSET__DfiM$Vq5__"